const comments = [
  {
    name: '影视达人小李',
    text: '神马视频真的太方便了！西瓜视频免费和菠萝视频的资源都能直接看，不用来回切换平台，画质也很清晰，推荐给身边所有追剧的朋友了。',
    rating: 5,
    time: '2小时前',
  },
  {
    name: '追剧少女小陈',
    text: '每天晚上回家第一件事就是打开神马视频看青青草视频的最新剧集，1080P高清不缓冲，比很多付费平台体验还好，必须给好评！',
    rating: 5,
    time: '5小时前',
  },
  {
    name: '老影迷张叔',
    text: '退休后就爱看经典老片，神马视频的老片库太全了，怀旧电影高清修复版都有，每天一部不重样，儿女都夸我找到好地方了。',
    rating: 4,
    time: '昨天',
  },
  {
    name: '二次元小宇',
    text: '作为动漫迷，神马视频的动漫番剧更新速度真的快，国漫日漫新番基本同步上线，弹幕文化也有，看番体验一级棒！',
    rating: 5,
    time: '昨天',
  },
  {
    name: '职场人阿杰',
    text: '通勤路上用手机看神马视频，加载速度很快，流量消耗也不大。中午休息刷一集剧刚刚好，已经成为我的日常标配了。',
    rating: 4,
    time: '2天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            真实用户观影反馈，听听大家怎么说
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-1 mb-2">
                {Array.from({ length: 5 }).map((_, j) => (
                  <i
                    key={j}
                    className={`ri-star-fill text-xs ${
                      j < comment.rating ? 'text-accent-500' : 'text-background-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                &ldquo;{comment.text}&rdquo;
              </p>
              <div className="flex items-center justify-between pt-3 border-t border-background-200">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-xs font-bold text-primary-600">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <span className="text-xs font-medium text-foreground-700">{comment.name}</span>
                </div>
                <span className="text-xs text-foreground-400">{comment.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}